module.exports = __webpack_public_path__ + "img/logo prolipa B.b96be594.png";